import config from '~~/config.json'

interface QueryParams {
  [key: string]: string | boolean | number | undefined
}

const avaliableHeaders = [
  'user-agent',
  'ali-cdn-real-ip',
  'x-forwarded-for',
  'x-real-ip',
  'x_r_ip'
]

interface Res<T> {
  code: number
  data: T
  msg: string
}

const { baseUrl, ganYuUrl } = config

export const http = {
  get: async <T>(url: string, params?: QueryParams) => {
    const headers = useRequestHeaders(avaliableHeaders)
    // console.log(headers)
    return $fetch<Res<T>>(url, {
      method: 'GET',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      params: params,
      baseURL: process.server ? process.env.LOCAL_API : baseUrl
    })
  },
  post: async <T>(url: string, body?: any) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'POST',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      body: body,
      baseURL: process.server ? process.env.LOCAL_API : baseUrl
    })
  },
  put: async <T>(url: string, body?: any) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'PUT',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      body: body,
      baseURL: process.server ? process.env.LOCAL_API : baseUrl
    })
  },
  delete: async <T>(url: string, body?: any) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'DELETE',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      body: body,
      baseURL: process.server ? process.env.LOCAL_API : baseUrl
    })
  }
}

export const ganYuHttp = {
  get: async <T>(url: string, params?: QueryParams) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'GET',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      params: params,
      baseURL: process.server ? process.env.GANYU_API : ganYuUrl
    })
  },
  post: async <T>(url: string, body?: any) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'POST',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      body: body,
      baseURL: process.server ? process.env.GANYU_API : ganYuUrl
    })
  },
  put: async <T>(url: string, body: any) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'PUT',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      body: body,
      baseURL: process.server ? process.env.GANYU_API : ganYuUrl
    })
  },
  delete: async <T>(url: string) => {
    const headers = useRequestHeaders(avaliableHeaders)
    return $fetch<Res<T>>(url, {
      method: 'DELETE',
      headers: {
        ...headers,
        Authorization: `${useAccessToken().value}`
      },
      baseURL: process.server ? process.env.GANYU_API : ganYuUrl
    })
  }
}
